export default __webpack_public_path__ + "static/media/hero-level-4-chars-desk.fc5a18f2.webp";